import { CommonPrintProps } from 'approot/activity-builder/activity-builder.constants';
import { PrintStimulusAspectRatio } from '../print/print-stimulus';
import { getPrintImage } from '../shared/logic/get-print-image';
import { ViewProps } from './ebook.constants';

const EbookPrint = (props: ViewProps & CommonPrintProps) =>
  props.stimulusResourceProperties?.documentKey ? (
    <PrintStimulusAspectRatio
      isPrintPreview={props.isPrintPreview}
      dimensions={props.properties.dimensionData}
      coverImage={
        getPrintImage(
          props.stimulusResourceProperties.xlCoverImageUrls || null
        ) || props.stimulusResourceProperties?.coverImage?.original
      }
      link={props.stimulusResourceProperties.link}
    />
  ) : null;

export default EbookPrint;
